import { openBrowserPopup } from 'Helpers/browserPopup'
import { logAppInfo } from 'Helpers/logger'
import { notifyParent, STORE_KEY_ACCOUNT, storeGet } from 'mailup-react-helpers'
import {
  Actions,
  DataListExtraColumn,
  DataListHeader,
  DataListRow,
  Grid,
  GridCell,
  Link,
  LINK_VARIANT_HIGHLIGHT,
  MENU_POSITION_LEFT,
  ModalConfirm,
  SKELETON_LOADER_VARIANT_ONWHITE,
  SkeletonLoader,
  SPACING_4,
  SpacingVertical,
  TruncateAndTooltip
} from 'mailup-web-components'
import iconDynCntEmail from 'mailup-web-components/resources/mailup-web-app/img/svg/icon-dyncontent-email.svg'
import iconDynCntRss from 'mailup-web-components/resources/mailup-web-app/img/svg/icon-dyncontent-feedrss.svg'
import iconDynCntWebsite from 'mailup-web-components/resources/mailup-web-app/img/svg/icon-dyncontent-webpage.svg'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'
import {
  deleteDynamicContentCallback,
  getDynamicContentListCallback
} from '../../recoil/callbacks/callbacks'
import {
  modalDeleteState,
  resultsState,
  searchState
} from '../../recoil/state/page'

import Pagination from '../Pagination'
import './Results.scss'
const Results = () => {
  const EXTRA_COLUMN_AFTER_WIDTH = '25px'
  const EXTRA_COLUMN_BEFORE_WIDTH = '15px'
  const intl = useIntl()
  const { orderBy, orderDescending, pageSize } = useRecoilValue(searchState)
  const { items, loadingTable } = useRecoilValue(resultsState)
  const getDynamicContentList = useRecoilCallback(
    getDynamicContentListCallback,
    []
  )
  const deleteDynamicContent = useRecoilCallback(
    deleteDynamicContentCallback,
    []
  )
  const [modalDelete, setModalDelete] = useRecoilState(modalDeleteState)

  const heads = [
    {
      label: intl.formatMessage({
        id: 'Load.DynamicContentList.HeaderTableName'
      }),
      span: 4,
      sortable: true,
      field: 'Name'
    },
    {
      label: intl.formatMessage({
        id: 'Load.DynamicContentList.HeaderTableFilter'
      }),
      span: 3
    },
    {
      label: intl.formatMessage({
        id: 'Load.DynamicContentList.HeaderLastMessageSent'
      }),
      span: 2
    },
    {
      label: intl.formatMessage({
        id: 'Load.DynamicContentList.HeaderCreationDate'
      }),
      span: 3,
      sortable: true,
      field: 'CreationDate'
    }
  ]

  function handleChangeColumnsOrder(field) {
    getDynamicContentList({
      orderBy: field,
      orderDescending: !orderDescending,
      pageNumber: 1
    })
  }

  function onClickPreview(item) {
    const idContent = item.Id
    const baseHost = storeGet(STORE_KEY_ACCOUNT).Domain
    openBrowserPopup(
      'https://' +
        baseHost +
        '/console/PreviewContenutiEsterni.aspx?idContenuto=' +
        idContent +
        '&popup=true'
    )
  }

  function onClickEdit(item) {
    notifyParent('redirectMainFrame', [
      'GestoreContenutiEsterni.aspx?idContenuto=' + item.Id
    ])
  }
  const renderIcon = (type) => {
    switch (type) {
      case 1:
        return (
          <img
            width='16'
            src={iconDynCntRss}
            data-tip={intl.formatMessage({
              id: 'Load.DynamicContentList.ContDinType_1'
            })}
          />
        )
      case 2:
        return (
          <img
            width='16'
            src={iconDynCntWebsite}
            data-tip={intl.formatMessage({
              id: 'Load.DynamicContentList.ContDinType_2'
            })}
          />
        )
      default:
        return (
          <img
            width='16'
            src={iconDynCntEmail}
            data-tip={intl.formatMessage({
              id: 'Load.DynamicContentList.ContDinType_3'
            })}
          />
        )
    }
  }

  function onClickDelete(item) {
    setModalDelete({
      show: true,
      id: item.Id,
      name: item.Name
    })
  }

  function getActionsItems(item) {
    const action = []
    action.push({
      label: intl.formatMessage({ id: 'Load.MailupCommon.Edit' }),
      onClick: onClickEdit,
      value: item,
      className: 'test-edit'
    })
    action.push({
      label: intl.formatMessage({ id: 'Load.MailupCommon.Delete' }),
      onClick: onClickDelete,
      value: item,
      className: 'test-delete',
      separator: true
    })
    return action
  }

  const closeModalDelete = () => {
    setModalDelete({ show: false })
  }

  const confirmDelete = async () => {
    await deleteDynamicContent({ idContent: modalDelete.id })
    logAppInfo({
      Component: 'DynamicContentList',
      Method: 'deleteDynamicContentCallback',
      Message: 'Delete Dynamic Content',
      Data: JSON.stringify(modalDelete.id)
    })
    getDynamicContentList({})
  }

  return (
    <>
      <ModalConfirm
        show={modalDelete.show}
        title={intl.formatMessage(
          {
            id: 'Load.DynamicContentList.DeleteTitle'
          },
          { NAME: modalDelete.name }
        )}
        message={intl.formatMessage({
          id: 'Load.DynamicContentList.DeleteDesc'
        })}
        stringConfirm={intl.formatMessage({ id: 'Load.MailupCommon.Delete' })}
        stringCancel={intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
        onClickCancel={closeModalDelete}
        onClickConfirm={confirmDelete}
        variant='delete'
      />
      <>
        {items.length > 0 && (
          <>
            <DataListHeader
              heads={heads}
              beforeWidth={EXTRA_COLUMN_BEFORE_WIDTH}
              afterWidth={EXTRA_COLUMN_AFTER_WIDTH}
              orderByStatus={orderBy}
              orderDescendingStatus={orderDescending}
              // eslint-disable-next-line react/jsx-no-bind
              handleChangeColumnsOrderCallback={handleChangeColumnsOrder}
            />
            <div>
              {loadingTable && (
                <>
                  {[...Array(pageSize)].map((item, key) => (
                    <DataListRow key={key}>
                      <Grid cols={12}>
                        <GridCell span={heads[0].span}>
                          <SkeletonLoader
                            variant={SKELETON_LOADER_VARIANT_ONWHITE}
                          />
                        </GridCell>
                        <GridCell span={heads[1].span}>
                          <SkeletonLoader
                            variant={SKELETON_LOADER_VARIANT_ONWHITE}
                          />
                        </GridCell>
                        <GridCell span={heads[2].span}>
                          <SkeletonLoader
                            variant={SKELETON_LOADER_VARIANT_ONWHITE}
                          />
                        </GridCell>
                        <GridCell span={heads[3].span}>
                          <SkeletonLoader
                            variant={SKELETON_LOADER_VARIANT_ONWHITE}
                          />
                        </GridCell>
                      </Grid>
                      <DataListExtraColumn
                        after
                        width={EXTRA_COLUMN_AFTER_WIDTH}
                      />
                    </DataListRow>
                  ))}
                </>
              )}

              {!loadingTable &&
                items.map((item, key) => (
                  <DataListRow key={key} data-mu-test='list-item'>
                    <DataListExtraColumn
                      before
                      width={EXTRA_COLUMN_BEFORE_WIDTH}
                    >
                      {renderIcon(item.Type)}
                    </DataListExtraColumn>
                    <Grid cols={12}>
                      <GridCell span={heads[0].span} data-mu-test='item-name'>
                        <Link
                          variant={LINK_VARIANT_HIGHLIGHT}
                          onClick={() => onClickPreview(item)}
                        >
                          <TruncateAndTooltip
                            data-mu-test='dynamiccontent-goToPreview'
                            text={item.Name}
                          />
                        </Link>
                        <SpacingVertical variant={SPACING_4} />

                        <TruncateAndTooltip text={'ID ' + item.Id} />
                      </GridCell>
                      <GridCell span={heads[1].span} data-mu-test='item-filter'>
                        {item.FilterName == null ? (
                          <SkeletonLoader
                            variant={SKELETON_LOADER_VARIANT_ONWHITE}
                          />
                        ) : (
                          <>
                            {' '}
                            <TruncateAndTooltip text={item.FilterName} />
                          </>
                        )}
                      </GridCell>
                      <GridCell
                        span={heads[2].span}
                        data-mu-test='item-lastsentdate'
                      >
                        {item.LastSendDate == null ? (
                          <SkeletonLoader
                            variant={SKELETON_LOADER_VARIANT_ONWHITE}
                          />
                        ) : (
                          <>{item.LastSendDate}</>
                        )}
                      </GridCell>
                      <GridCell
                        span={heads[3].span}
                        data-mu-test='item-creationdate'
                      >
                        {item.CreationDate}
                      </GridCell>
                    </Grid>
                    <DataListExtraColumn after width={EXTRA_COLUMN_AFTER_WIDTH}>
                      <Actions
                        menuPosition={MENU_POSITION_LEFT}
                        items={getActionsItems(item)}
                        data-mu-test={'item-actions item-actions_' + item.Id}
                      />
                    </DataListExtraColumn>
                  </DataListRow>
                ))}
            </div>
            <Pagination />
          </>
        )}
      </>
    </>
  )
}

export default Results
